import React from "react";
import { Route } from "react-router-dom";
import Contact from "../components/index";

const ContactRoutes = () => {
  return (
    <>
      <Route path="/contact" element={<Contact />} /> 
    </>
  );
};

export default ContactRoutes;
